/**
 * Contact FAQ Section Script
 * Handles accordion functionality with scoped selectors.
 */

window.initContactFaq = function(sectionId) {
  // Scope to the specific section instance
  const section = document.getElementById(`shopify-section-${sectionId}`) || document.getElementById(sectionId);
  if (!section) return;

  const container = section.querySelector('.contact-faq');
  if (!container) return;

  const smoothAnimationEnabled = container.getAttribute('data-smooth-animation') === 'true';
  const details = container.querySelectorAll('.faq-item');

  details.forEach((detail) => {
    const summary = detail.querySelector('.faq-item__button');

    // Remove existing listeners to prevent duplication if re-initialized
    const newSummary = summary.cloneNode(true);
    summary.parentNode.replaceChild(newSummary, summary);

    newSummary.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default instant toggle

      if (detail.hasAttribute('open')) {
        // Closing
        if (smoothAnimationEnabled) {
          detail.classList.add('is-closing');
          setTimeout(() => {
            detail.removeAttribute('open');
            detail.classList.remove('is-closing');
          }, 300);
        } else {
          detail.removeAttribute('open');
        }
      } else {
        // Close all other items first (accordion behavior)
        details.forEach((d) => {
          if (d !== detail && d.hasAttribute('open')) {
            if (smoothAnimationEnabled) {
              d.classList.add('is-closing');
              setTimeout(() => {
                d.removeAttribute('open');
                d.classList.remove('is-closing');
              }, 300);
            } else {
              d.removeAttribute('open');
            }
          }
        });

        // Open this item
        detail.setAttribute('open', '');

        if (smoothAnimationEnabled) {
          requestAnimationFrame(() => {
            detail.classList.add('is-opening');
            requestAnimationFrame(() => {
              detail.classList.remove('is-opening');
            });
          });
        }
      }
    });
  });
};

// Auto-initialize all contact-faq sections on page load
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.contact-faq');
    sections.forEach(function(container) {
      const sectionElement = container.closest('[id^="shopify-section-"]');
      if (sectionElement) {
        const sectionId = sectionElement.id.replace('shopify-section-', '');
        window.initContactFaq(sectionId);
      }
    });
  });
})();
